<template>
  <div class="header-section">
    <div class="logo">
      <div class="logo-icon">🌱</div>
      <h1>NutriQuest</h1>
    </div>
    <div class="user-info">
      <div class="user-level">
        <h3>{{ user.name }}</h3>
        <p>Niveau {{ user.level }} - Chêne Junior</p>
      </div>
      <div class="avatar">{{ user.avatar }}</div>
    </div>
  </div>
</template>
<script>
export default {
  name: "HeaderSection",
  props: {
    user: { type: Object, required: true },
  },
}
</script>
<style scoped>
.header-section {
  background: white;
  padding: 20px 30px;
  margin-bottom: 25px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}
.logo {
  display: flex;
  align-items: center;
  gap: 15px;
}
.logo-icon {
  width: 50px;
  height: 50px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
}
.logo h1 {
  font-size: 28px;
  color: #2d3748;
}
.user-info {
  display: flex;
  align-items: center;
  gap: 15px;
}
.user-level {
  text-align: right;
}
.user-level h3 {
  color: #2d3748;
  font-size: 16px;
}
.user-level p {
  color: #718096;
  font-size: 13px;
}
.avatar {
  width: 50px;
  height: 50px;
  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
}
</style>
